import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AppContext } from "../context/AppContext";

const SuperAdminAuth = ({ children }) => {
  //   const isAuth = useSelector((store) => store.auth.token);
  const { isSuperAdmin } = useContext(AppContext);
  const { pathname } = useLocation();
  if (isSuperAdmin) {
    return children;
  } else {
    return <Navigate to="/login" state={{ from: pathname }} replace />;
  };
};

export default SuperAdminAuth;
